import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function RolePlayingLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer mb-4" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/rpg" id="categories-roleplaying" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.role-playing" defaultMessage="Role Playing" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/action-rpg" id="categories-actionrpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.action-rpg" defaultMessage="Action RPG" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/adventure-rpg" id="categories-adventurerpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.adventure-rpg" defaultMessage="Adventure RPG" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/jrpg" id="categories-jrpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.jrpg" defaultMessage="JRPG" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/roguelike" id="categories-roguelike" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.roguelike" defaultMessage="Roguelike" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/strategy-rpg" id="categories-strategyrpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.strategy-rpg" defaultMessage="Strategy RPG" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/tactical-rpg" id="categories-tacticalrpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="role-playing-links.link.tactical-rpg" defaultMessage="Tactical RPG" />
        </TrackingLink>
      </li>
    </ul>
  );
}

RolePlayingLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

RolePlayingLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
